import React from 'react';
import * as _ from 'lodash';
import Kendra from 'aws-sdk/clients/kendra';
import { Header, Link } from '@cloudscape-design/components';
import { useNavGraph } from 'src/components/providers/NavGraphProvider';
import { findInNavGraphV2 } from 'src/utils/findInNavGraph';
import { publishKendraClickThrough } from '../../../kendraMetrics';

interface ResultTitleProps {
    queryResultItem: Kendra.QueryResultItem;
    attributes: any;
    topicUrl: string;
    documentTitle: string;
    documentId: string;
    topicId: string;
    topicName: string;
    queryText?: string;
    userId?: string;
    resultPosition?: number;
}

const getStringFromDocAttributes = (
    attributes: Record<string, any>,
    key: string
): string | undefined => attributes[key]?.StringValue;

export const ResultTitle = ({
    queryResultItem,
    attributes,
    topicUrl,
    documentTitle,
    documentId,
    topicId = '',
    topicName = '',
    queryText = '',
    userId = '',
    resultPosition = 0,
}: ResultTitleProps) => {
    const { navGraph } = useNavGraph();

    const handleClick = (e: any) => {
        if (userId && queryText) {
            publishKendraClickThrough(
                userId,
                queryText,
                documentId,
                resultPosition,
                topicId,
                topicName
            );
        }
    };

    const getImageUrl = (id: string) => {
        const document = findInNavGraphV2(parseInt(id), navGraph);
        return document?.pictureUrl || '';
    };

    const imageUrl = getImageUrl(documentId);

    let title: string;
    if (
        queryResultItem.DocumentTitle &&
        !_.isEmpty(queryResultItem.DocumentTitle.Text)
    ) {
        title = `${documentTitle} > ${queryResultItem.DocumentTitle.Text}`;
    } else {
        title = documentTitle;
    }

    const resultTitle = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {imageUrl && (
                <img
                    alt=""
                    src={imageUrl}
                    style={{
                        width: '50px',
                        marginRight: '20px',
                    }}
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            )}
            <Link
                onClick={(e) => {
                    handleClick(e);
                }}
                href={topicUrl}
            >
                {title}
            </Link>
        </div>
    );

    return <Header variant="h3">{resultTitle}</Header>;
};
